import React from 'react';
import { Form } from 'react-bootstrap';
import RaisedButton from 'material-ui/RaisedButton';

import EditorForm from './editor_form';
import SaveFileDialog from './save_file_dialog';
import DocumentList from './document_list';
import Drawer from 'material-ui/Drawer';
import IconButton from 'material-ui/IconButton'
import Menu from 'material-ui/svg-icons/navigation/menu';


class Editor extends React.Component {
    constructor() {
        super();

        this.state = {
            saveDialogOpen: false,
            open: false
        };

        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleSaveButtonClick = this.handleSaveButtonClick.bind(this);
        this.handleSaveDocument = this.handleSaveDocument.bind(this);
        this.handleMove = this.handleMove.bind(this);
    }

    componentDidMount() {
        const { imageUrl } = this.props;
        this.loadDocumentImage(imageUrl);
    }

    componentDidUpdate() {
        if (this.props.isDocumentFinished) {
            this.handleFinalizingDocument();
        }
    }

    loadDocumentImage(imageUrl) {
        this.outerDiv.style.setProperty('background-image', `url(${imageUrl})`)

        const img = new Image();
        img.src = imageUrl;
        img.onload = () => {
            if (this.outerDiv) {
                this.outerDiv.style.setProperty('height', `${img.height}px`);
                this.outerDiv.style.setProperty('width', `${img.width}px`);
            }
        };
    }

    handleDocumentClick(event) {
        const bounds = event.target.getBoundingClientRect();
        const left = event.clientX - bounds.left;
        const top = event.clientY - bounds.top;
        this.props.addInput(top, left);
    }

    handleSaveButtonClick() {
        this.setState({
            saveDialogOpen: true
        });
    }

    handleSaveDocument(filename, wasCancelled) {
        this.setState({
            saveDialogOpen: false
        });

        if (!wasCancelled) {
            this.props.saveCurrentDocument(filename)
        }
    }

    handleToggle = () => this.setState({open: !this.state.open});

    handleMove(formData, event) {
        const bounds = this.outerDiv.getBoundingClientRect();
        const left = event.clientX - bounds.left;
        const top = event.clientY - bounds.top;
        this.props.moveInput(formData.id, top, left);
    }

    handleFinalizingDocument() {
        const htmlToConvert = this.outerDiv.outerHTML;
        const requestBody = JSON.stringify({ html: htmlToConvert });

        this.props.createPdf(htmlToConvert, 'document.pdf');
        this.props.finishedFinalizingDocument()
    }

    render() {
        const { formData, deleteInput, updateInput, isDocumentFinished, finishDocument, staticDocuments, userDocuments, onLoadNewDocument, onLoadExistingDocument } = this.props;
        const { saveDialogOpen } = this.state;

        let formElements = Object.values(formData).map(f => {
            return (
                <EditorForm
                    formData={f}
                    editable={!isDocumentFinished} key={f.id}
                    onDelete={deleteInput}
                    onChange={updateInput}
                    handleMove={(event) => this.handleMove(f, event)}
                    position={{ x: f.left, y: f.top }}
                />
            );
        });

        const buttonStyle = {
            margin: 12,
            padding: 2
        };

        return (
            <div>
              {/*<Drawer style={{ position: 'fixed', flex: 1, width: 134, right: 4, backgroundColor: '#333333', textAlign: 'center', borderRadius: 10 }}>*/}
              <Drawer width={110} openSecondary={true} open={this.state.open} containerStyle={{ backgroundColor: '#333333', top: 40, paddingTop: 25 }} >
                <RaisedButton
                    type='button'
                    onClick={() => this.props.setNextInputType('text')}
                    style={buttonStyle}

                >
                    Text Box
                </RaisedButton>
                <RaisedButton
                    type='button'
                    onClick={() => this.props.setNextInputType('checkbox')}
                    style={buttonStyle}

                >
                    Check Box
                </RaisedButton>
                <RaisedButton
                    type='button'
                    onClick={() => this.props.setNextInputType('date')}
                    style={buttonStyle}

                    >
                    Date
                </RaisedButton>
                <RaisedButton
                    type='button'
                    onClick={() => this.props.setNextInputType('signature')}
                    style={buttonStyle}

                    >
                    Signature
                </RaisedButton>
                <RaisedButton
                    type='button'
                    onClick={this.handleSaveButtonClick}
                    style={buttonStyle}

                >
                    Save
                </RaisedButton>
                <RaisedButton
                    type='button'
                    onClick={this.props.finishDocument}
                    style={buttonStyle}

                >
                    Finish
                </RaisedButton>
                <DocumentList
                    staticDocuments={staticDocuments}
                    userDocuments={userDocuments}
                    onLoadNewDocument={onLoadNewDocument}
                    onLoadExistingDocument={onLoadExistingDocument}
                />
            </Drawer>
                <IconButton tooltip="Open Tools" style={{ position: 'fixed'}} onClick={this.handleToggle} >
                  <Menu />
                </IconButton>
                <div
                    ref={ref => this.outerDiv = ref}
                    onClick={(this.handleDocumentClick)}
                    id="doc-editor"
                >
                    {formElements}
                </div>

                <SaveFileDialog open={saveDialogOpen} onClose={this.handleSaveDocument} />
            </div>
        );
    }
}

export default Editor;



// WEBPACK FOOTER //
// ./src/components/document-editor/editor.jsx